type SyncLogEntry = { message: string; severity: string; location: string };

/**
 * Filtert MyJack-Sync-Fehlermeldungen nach Prioritaet und blendet Folgefehler aus.
 *
 * Prio 1: "Berater nicht gefunden" -> nur diesen Fehler anzeigen
 * Prio 2: "Kein myJACK Unit" -> Folgefehler zu AdressID/Vertragsinhaber/Steuernummer ausblenden
 * Prio 3: Rate-Limit-Fehler komplett ausblenden (nicht relevant fuer den User)
 * Prio 4: Alle uebrigen Fehler normal anzeigen
 */
function filterSyncErrors(logs: SyncLogEntry[]): SyncLogEntry[] {
  if (!logs || logs.length === 0) return logs;

  // Prio 1: "Berater nicht gefunden" — nur diesen Fehler anzeigen
  const beraterNichtGefunden = logs.find((log) =>
    log.message.toLowerCase().includes('berater in myjack nicht gefunden'),
  );

  if (beraterNichtGefunden) {
    return [beraterNichtGefunden];
  }

  // Prio 2: "Kein myJACK Unit" — Folgefehler ausblenden
  const hasKeinUnit = logs.some((log) => {
    const msg = log.message.toLowerCase();
    return msg.includes('kein myjack unit') || msg.includes('keine myjack unit');
  });

  let filtered = logs;

  if (hasKeinUnit) {
    const followUpPatterns = [
      'adressid',
      'vertragsinhaber',
      'steuernummer',
      'ust.-idnr',
      'umsatzsteuerid',
      'umsatzsteurid',
    ];

    filtered = filtered.filter((log) => {
      const msgLower = log.message.toLowerCase();
      // Behalte den "Kein Unit"-Fehler selbst
      if (msgLower.includes('kein myjack unit') || msgLower.includes('keine myjack unit')) {
        return true;
      }
      // Entferne Folgefehler die durch fehlendes Unit verursacht werden
      return !followUpPatterns.some((pattern) => msgLower.includes(pattern));
    });
  }

  // Prio 3: Rate-Limit-Fehler komplett ausblenden (nicht relevant fuer den User)
  filtered = filtered.filter((log) => !log.message.toLowerCase().includes('rate limit'));

  return filtered;
}

export default filterSyncErrors;
